import React from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  withStyles,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import { withUserProfile } from "../../../../../../../userProfile/userProfileContext";
import { compose } from "recompose";
const styles = (theme) => ({
  dialogTitle: {
    padding: 8,
    borderBottom: `1px solid ${theme.AppBGColor}`,
    paddingLeft: 24,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  dialog: {
    padding: 0,
    boxSizing: "border-box",
    borderRadius: "2px",
    backgroundColor: theme.ModalBGColor,
    boxShadow: "2px 2px 4px black",
    minWidth: "80%",
    maxWidth: "80%",
    height: "100%",
  },
  dialogContent: {
    padding: 0,
    overflow: "hidden",
  },
  closeButton: {
    color: theme.iconColor,
  },
  title: {
    color: theme.HeaderSelectedText,
    fontSize: "14px",
    fontWeight: 600,
    top: "19px",
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle
      disableTypography
      classes={{ root: classes.dialogTitle }}
      {...other}
    >
      <Typography variant="h6" className={classes.title}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const Modal = (props) => {
  const { handleClose, classes, open, title, children } = props;
  const { theme } = props.userData.userProfile || {};
  return (
    <Dialog
      maxWidth="lg"
      aria-labelledby="dialog-title"
      open={open}
      classes={{ paper: classes.dialog }}
      className={theme === "dark" ? "darkTheme" : "lightTheme"}
    >
      <DialogTitle id="dialog-title" onClose={handleClose}>
        {title}
      </DialogTitle>
      <DialogContent classes={{ root: classes.dialogContent }}>
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default compose(withUserProfile, withStyles(styles))(Modal);
